import { type BaseObject } from './Base';
import type { CompanySite } from './Companies';

export type SalesPerson = BaseObject & {
  code: string;
  name: string;
  userID?: string;
  sequence?: number;
  rootCode?: string;
  BOID?: string;
  salesPersonParentID?: string | null;
  companySiteID?: string;
  mwSalesPersonTypeID?: string;
  mwSalesPersonsAccessMaxLevelID?: string;
  companySite?: CompanySite;
  mwSalesPersonType?: SalesPersonType;
  mwSalesPersonsAccessMaxLevel?: SalesPersonsAccessLevel;
  onlineSearchLevel: eOnlineSearchLevel;
  onlineSearchLevelValue?: string;
  salesPersonParentId?: string;
};

export type SalesPersonType = BaseObject & {
  code: string;
  name: string;
};

export type SalesPersonsAccessLevel = {
  id: string;
  name: string;
  level: number;
};

export enum eOnlineSearchLevel {
  UpToMaxAccessLevel = 1,
  All = 2,
}
